<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

// 页面挂载时初始化用户状态
onMounted(() => {})
</script>
<style lang="scss">
/* 根组件样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,
body,
#app {
  height: 100%;
}
</style>
